<div class="payment-failed-container fx-pointer-events-auto" *ngIf="showPaymentFailedMessage">
    <div class="payment-failed-inner fx-center-vertical">
        <div class="payment-failed-icon">
            <svg class="nu-icon nu-icon-small white">
                <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-su-error"></use>
            </svg>
        </div>
        <div class="payment-failed-text body">
            <span>
                {{translate.get( 'PAYMENT_FAILED_MESSAGES.HEADER_MSG_PART1_SUB1' )|async}}   
            </span>
            <span>
                {{translate.get( 'PAYMENT_FAILED_MESSAGES.HEADER_MSG_PART1_SUB2' )|async}}
            </span>
            <span>
                {{translate.get( 'PAYMENT_FAILED_MESSAGES.HEADER_MSG_PART1_SUB3' )|async}}   
            </span>
            <span>
                {{translate.get( 'PAYMENT_FAILED_MESSAGES.HEADER_MSG_PART2' )|async}}
            </span>
            <button [trackAction]="{ event: 'conversion.payment-failed.banner.click'}" class="payment-failed-auth-link btn-link" (click)="showBillingPage()">
                {{translate.get( 'PAYMENT_FAILED_MESSAGES.BUTTONS' )|async}}
            </button>
        </div>
    </div>
</div>
